module.exports = __webpack_public_path__ + "img/linkedIn.fc4af4b7.svg";